<template>
  <div style="position: relative; height: 100%; width: 100%;">
    <Pie :data="chartData" :options="enhancedOptions" />
  </div>
</template>

<script>
import { Pie } from 'vue-chartjs'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement
} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, ArcElement)

export default {
  name: 'SimplePieChart',
  components: { Pie },
  props: {
    chartData: Object,
    chartOptions: Object
  },
  computed: {
    enhancedOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            position: 'bottom',
            labels: {
              boxWidth: 12,
              padding: 16,
              font: { size: 11 }
            }
          },
          tooltip: {
            callbacks: {
              label: (context) => {
                const label = context.label || '';
                const value = context.parsed || 0;
                const total = context.dataset.data.reduce((a, b) => a + b, 0);
                const percentage = ((value / total) * 100).toFixed(1);
                return `${label}: ${value} kWh (${percentage}%)`;
              }
            }
          }
        },
        ...(this.chartOptions || {})
      }
    }
  }
}
</script>